/* eslint-disable react/jsx-filename-extension */
import React from 'react';
import { Avatar } from '@mui/material';
import * as R from 'ramda';
import ArtTrackIcon from '@mui/icons-material/ArtTrackRounded';
import RepeatRoundedIcon from '@mui/icons-material/RepeatRounded';
import LowPriorityRoundedIcon from '@mui/icons-material/LowPriorityRounded';
import LocalShippingRoundedIcon from '@mui/icons-material/LocalShippingRounded';
import AccountBoxRoundedIcon from '@mui/icons-material/AccountBoxRounded';
import ContactsRoundedIcon from '@mui/icons-material/ContactsRounded';
import AdminPanelSettingsRoundedIcon from '@mui/icons-material/AdminPanelSettingsRounded';
import HomeIcon from '@mui/icons-material/Home';
import AltRouteIcon from '@mui/icons-material/AltRoute';
import LockIcon from '@mui/icons-material/Lock';
import DonutLargeIcon from '@mui/icons-material/DonutLarge';
import MediationIcon from '@mui/icons-material/Mediation';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import { ReactComponent as FactCheckIcon } from 'assets/img/fact_check_rounded.svg';
import PercentIcon from '@mui/icons-material/Percent';

import { TOP_NAVIGATION_LINKS } from './routes';

const showDispatching = process.env.REACT_APP_SHOW_DISPATCHING === 'true';

export const leftNavLinkIcon = (link, id, currentOpenSubList) => {
  const getLeftIcon = R.cond([
    // Inventory Ownership
    [R.equals('Inventory Dashboard'), R.always(<DonutLargeIcon />)],
    [
      R.equals('Product Transfer Orders'),
      R.always(
        <Avatar
          sx={{
            '& > svg': {
              fill: 'surface.white',
              fontSize: 'inherit',
            },
            backgroundColor: id === currentOpenSubList ? 'primary.main' : 'primary.light',
            fontSize: 18,
            height: 24,
            width: 24,
          }}
        >
          <RepeatRoundedIcon sx={{ color: 'surface.white' }} />
        </Avatar>
      ),
    ],
    [R.equals('Reconsignments'), R.always(<AltRouteIcon />)],
    // Shipping
    [R.equals('Shipping'), R.always(<LocalShippingRoundedIcon />)],
    [R.equals('Batches'), R.always(<MediationIcon />)],
    [R.equals('Monthly Nominations'), R.always(<TimerOutlinedIcon />)],
    // Product Loading
    [
      R.equals('Authorization Sequencing'),
      R.always(<LowPriorityRoundedIcon sx={{ transform: 'rotate(180deg)' }} />),
    ],
    [R.equals('My Authorizations'), R.always(<LockIcon />)],
    [R.equals('Supplier Authorizations'), R.always(<AccountBoxRoundedIcon />)],
    [R.equals('Customer Authorizations'), R.always(<ContactsRoundedIcon />)],
    [R.equals('Carrier Authorizations'), R.always(<LocalShippingRoundedIcon />)],
    [R.equals('Self Authorizations'), R.always(<AdminPanelSettingsRoundedIcon />)],
    [R.equals('Terminal Information'), R.always(<ArtTrackIcon />)],
    [R.equals('Terminal Allocation Loading Percentage'), R.always(<PercentIcon />)],
    // Dispatching
    [R.equals('Loads'), R.always(<FactCheckIcon />)],
    [R.equals('Compliance'), R.always(<FactCheckIcon />)],
    [R.equals('Loads Plan'), R.always(<FactCheckIcon />)],
    // Global Data
    [R.equals('Points'), R.always(<FactCheckIcon />)],
    [R.equals('Products'), R.always(<FactCheckIcon />)],
    [R.equals('Destinations'), R.always(<FactCheckIcon />)],
    // Home
    [R.equals('Home'), R.always(<HomeIcon />)],
  ]);
  return getLeftIcon(link);
};

const getNonSubrouteRoutes = R.compose(
  R.find(R.and(R.propEq('label', 'Customer Authorizations'), R.propEq('label', 'Reconsignments'))),
  R.flatten,
  R.pluck('subRoutes')
)(TOP_NAVIGATION_LINKS);

export const onlyBaseRoutes = R.compose(
  R.filter(x => x),
  R.prepend(getNonSubrouteRoutes),
  R.flatten,
  R.pluck('subRoutes'),
  R.flatten,
  R.pluck('subRoutes')
)(TOP_NAVIGATION_LINKS);

const getRouteList =
  defaultReturn =>
  (pathname, baseList = TOP_NAVIGATION_LINKS) =>
    R.compose(
      R.defaultTo(defaultReturn),
      R.find(R.o(R.startsWith(R.__, pathname), R.prop('route'))),
      R.filter(R.prop('route'))
    )(baseList);

export const getSubList = getRouteList({ id: 0 }); // DEFAULT TO INVENTORY OWNERSHIP ID - 0
export const getCurrentTab = getRouteList(
  TOP_NAVIGATION_LINKS[showDispatching ? TOP_NAVIGATION_LINKS.length - 1 : 3]
); // DEFAULT TO DASHBOARD INDEX IN TOP_NAV_LINKS

// this is a handy function to use with the same argument, but different functions
const callFun = arg => fun => fun(arg);

export const getMenuOptions = roles =>
  R.compose(
    R.map(
      R.o(
        R.zipObj(['value', 'label', 'ldfeature', 'ldelse']),
        R.props(['id', 'label', 'ldfeature', 'ldelse'])
      )
    ),
    R.filter(R.o(callFun(roles), R.prop('userRoles')))
  )(TOP_NAVIGATION_LINKS);

export const getRoute = id =>
  R.compose(R.prop('route'), R.find(R.propEq('id', id)))(TOP_NAVIGATION_LINKS);
